import { CountChart } from './components/CountChart/CountChart';
import React from 'react';
import { Skeleton } from '@mui/material';
import { ValuationsChart } from './components/ValuationsChart';
import { useGetMaOpportunitiesSummary } from './hooks/useGetMaOpportunitiesSummary';
import { useStyles } from './styles';

const OpportunitiesSummarySkeleton = () => {
  const classes = useStyles();

  return (
    <div className={classes.boxes}>
      {Array.from({ length: 5 }).map((_, i) => (
        <div className={classes.box} key={i}>
          <Skeleton
            animation="wave"
            variant="text"
            width={50}
            height={35}
            style={{ marginTop: '-5px' }}
          />
          <Skeleton
            animation="wave"
            variant="text"
            width={200}
            height={15}
            style={{ marginTop: '-5px' }}
          />
        </div>
      ))}
    </div>
  );
};

const OpportunitiesSummary = () => {
  const classes = useStyles();
  const { data, loading, error } = useGetMaOpportunitiesSummary();

  if (error) return null;

  if (loading) return <OpportunitiesSummarySkeleton />;

  const boxes = [
    { value: data.count, name: 'Number of Opportunities' },
    { value: Math.round(data.medianValuation), name: 'Estimated Median Valuation (US$MM)' },
    { value: Math.round(data.medianReserves), name: 'Estimated Median Remaining Reserves (MMboe)' },
    { value: Math.round(data.medianProduction), name: 'Estimated Median Production (boe/d)' },
    { value: Math.round(data.medianCapex), name: 'Estimated Median Remaining Capex (US$MM)' },
  ];

  return (
    <div className={classes.boxes}>
      {boxes.map(({ name, value }) => (
        <div className={classes.box} key={name}>
          <div className={classes.boxValue}>{new Intl.NumberFormat('en-US').format(value)}</div>
          <div className={classes.boxName}>{name}</div>
        </div>
      ))}
    </div>
  );
};

export const OpportunitiesAnalytics = () => {
  const classes = useStyles();

  return (
    <>
      <OpportunitiesSummary />
      <div className={classes.graphWrapper}>
        <ValuationsChart />
        <CountChart />
      </div>
    </>
  );
};
